// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1448":"954bd373","4548":"c38fef53","12752":"8a647176","25776":"8a647176","32622":"8a647176","42396":"80b81a22"}[chunkId] + ".chunk.css";
};